<template>
  <div class="banner">
    <!-- Swiper 组件 -->
    <swiper :options="swiperOption">
      <swiper-slide>
        <div  class="slide-inner">
          <img src="@/assets/images/banner1.jpg" alt="Slide 1" />
        </div>
      </swiper-slide>
      <swiper-slide>
        <div  class="slide-inner">
          <img src="@/assets/images/banner2.jpg" alt="Slide 1" />
        </div>
      </swiper-slide>
      <swiper-slide>
        <div  class="slide-inner">
          <img src="@/assets/images/banner3.jpg" alt="Slide 1" />
        </div>
      </swiper-slide>

      <!-- 分页控制 -->
      <div slot="pagination" class="swiper-pagination"></div>
      <!-- 导航按钮 -->
      <div slot="button-prev" class="swiper-button-prev"></div>
      <div slot="button-next" class="swiper-button-next"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'HomeBanner',  // 组件名称
  data() {
    return {
      interleaveOffset: 0.5,
      // Swiper 配置选项
      swiperOption: {
          loop: true,
          speed: 1000,
          grabCursor: true,
          watchSlidesProgress: true,
          mousewheelControl: true,
          keyboardControl: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          autoplay: {
            delay: 3000, // 每隔 3 秒切换一次（可自己改）
            disableOnInteraction: false, // 重点：用户滑动后继续自动轮播
          },
      },
    };
  },
};
</script>

<style scoped>
.banner{
  width: 100%;
  /* height: 600px; */
}
/* 样式 */
.swiper-container {
  width: 100%;
}

.swiper-slide img {
  width: 100%;
  height: auto;
  object-fit: cover;  /* 确保图片自适应 */
}

.swiper-pagination {
  bottom: 10px;
}
img{
  display: block;
}
</style>
